var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15953_2305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2.10742C8.89303 2.10742 7.32214 2.58394 5.986 3.47673C4.64985 4.36952 3.60844 5.63847 2.99348 7.12312C2.37852 8.60777 2.21762 10.2414 2.53112 11.8175C2.84463 13.3936 3.61846 14.8414 4.75476 15.9777C5.89106 17.114 7.3388 17.8878 8.9149 18.2013C10.491 18.5148 12.1247 18.3539 13.6093 17.7389C15.094 17.124 16.3629 16.0826 17.2557 14.7464C18.1485 13.4103 18.625 11.8394 18.625 10.2324C18.6227 8.07824 17.766 6.01293 16.2427 4.48969C14.7195 2.96645 12.6542 2.1097 10.5 2.10742ZM14.0672 8.79961L9.69219 13.1746C9.63415 13.2327 9.56522 13.2788 9.48934 13.3103C9.41347 13.3417 9.33214 13.3579 9.25 13.3579C9.16787 13.3579 9.08654 13.3417 9.01067 13.3103C8.93479 13.2788 8.86586 13.2327 8.80782 13.1746L6.93282 11.2996C6.81554 11.1823 6.74966 11.0233 6.74966 10.8574C6.74966 10.6916 6.81554 10.5325 6.93282 10.4152C7.05009 10.298 7.20915 10.2321 7.375 10.2321C7.54086 10.2321 7.69992 10.298 7.81719 10.4152L9.25 11.8488L13.1828 7.91523C13.2409 7.85717 13.3098 7.8111 13.3857 7.77968C13.4616 7.74825 13.5429 7.73207 13.625 7.73207C13.7071 7.73207 13.7884 7.74825 13.8643 7.77968C13.9402 7.8111 14.0091 7.85717 14.0672 7.91523C14.1253 7.9733 14.1713 8.04224 14.2027 8.11811C14.2342 8.19398 14.2504 8.2753 14.2504 8.35742C14.2504 8.43954 14.2342 8.52086 14.2027 8.59673C14.1713 8.6726 14.1253 8.74154 14.0672 8.79961Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15953_2305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.232422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.6fab5021b14f56fa1ab90c1b31e63a16.svg";
export { ForwardRef as ReactComponent };